import { isAuthenticated } from '@/auth/authGuard'
import { LazyLoadView } from '@/router/utils'

export default [
  {
    name: 'residential-account-login',
    path: '/residential-account/login',
    component: () =>
      LazyLoadView(import(/* webpackChunkName: "residential-account-login" */ '@/views/ResidentialAccount/Login.vue')),
    meta: {
      skipAuth: true,
      navigation: false,
      footer: false,
    },
  },
  {
    name: 'residential-account',
    path: '/residential-account/:id',
    props: true,
    component: () =>
      LazyLoadView(import(/* webpackChunkName: "residential-account" */ '@/views/ResidentialAccount/View.vue')),
    meta: {
      skipAuth: true,
      navigation: false,
      footer: false,
    },
  },
  {
    name: 'residential-account-mutate',
    path: '/residential-account/:id/edit',
    props: true,
    component: () =>
      LazyLoadView(
        import(
          /* webpackChunkName: "residential-account-mutate" */ '@/views/ResidentialAccount/Dashboard/Component.vue'
        ),
      ),
    beforeEnter: isAuthenticated,
  },
  {
    name: 'residential-accounts',
    path: '/residential-accounts',
    component: () =>
      LazyLoadView(
        import(/* webpackChunkName: "residential-accounts" */ '@/views/ResidentialAccount/ResidentialAccounts.vue'),
      ),
    meta: {
      skipAuth: true,
      navigation: false,
      footer: false,
    },
  },
]
